import React from 'react';
import { Link } from 'react-router-dom';
import "./legend-item.css";


const LegendItem = ({color, value, count, percent, link}) => {
  return (
    <div className="legend_item">
      <div className="legend_item__text" style={{width: '25%', display: 'flex', justifyContent: 'center'}}>
        <div style={{background: color}} className="legend_item__circle" />
      </div>
      <div className="legend_item__text" style={{width: '35%'}}>
        {
          link ?
            <Link to={link} className="legend_item__link">
              {value}
            </Link>
            :
            value
        }

      </div>
      <div className="legend_item__text">{count}</div>
      <div className="legend_item__text">{percent}%</div>
    </div>
  )
};

export default LegendItem;


// WEBPACK FOOTER //
// ./src/components/pie-chart-legend/legend-item-component.js